import { toast } from "react-toastify";


export const copyToClipboard = async (text, label = "Text") => {
    try {
        await navigator.clipboard.writeText(text);
        toast.success(`${label} copied!`);
    } catch (err) {
        console.error(err);
        toast.error("Failed to copy.");
    }
};